import { action, observable } from "mobx";
import { BaseViewStore } from 'core/stores';
import applicationContext from 'core/utils/applicationContext';
import { FacilityService } from 'application/facility/services';

@applicationContext
class FacilityPayerValidationModalStore extends BaseViewStore {
    @observable accessor isRunning = false;
    @observable accessor hasRun = false;
    @observable accessor isValid = false;
    @observable accessor errors = [];

    constructor(rootStore, componentProps) {
        super(rootStore, {
            name: 'facility-payer-validation-modal',
            autoInit: true,
            routes: {}
        });

        this.service = new FacilityService(rootStore.application.baasic.apiClient);
        this.modalParams = componentProps.modalParams;
        this.modalData = componentProps.modalParams.data;
    }

    @action.bound
    async syncAndValidate() {
        this.isRunning = true;
        try {
            // One call: the server pulls this facility's payers into the local catalog, then validates the
            // timeline. The sync does not feed the validation - that reads Niko live - it is what stops the
            // portal's own insurance list showing the renamed payer under its old name.
            const response = await this.service.syncAndValidatePayers(this.modalData.facilityId);
            this.setResult(response.data.isValid, response.data.errors);

            if (this.isValid && this.modalData.onValidated) {
                this.modalData.onValidated();
            }
        }
        catch (err) {
            // An unreachable Niko lands here. It reads as one more thing to fix and retry with the same button,
            // so it goes in the same list rather than a separate notification.
            this.setResult(false, [
                (err && err.data && err.data.errors) || 'Sync and validation could not be completed. Please try again.'
            ]);
        }
        finally {
            this.setRunning(false);
        }
    }

    @action.bound
    setResult(isValid, errors) {
        this.isValid = isValid;
        this.errors = errors || [];
        this.hasRun = true;
    }

    @action.bound
    setRunning(isRunning) {
        this.isRunning = isRunning;
    }
}

export default FacilityPayerValidationModalStore;
